<template>
  <div
    v-if="mapData.longitude && mapData.latitude"
    id="yandex-map"
    data-qa="contacts-map"
    class="contacts-map"
    :class="isMobile ? 'contacts-map--mobile mt-4' : 'mt-8'"
  />
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue'
import { useContextStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/info/contacts/types'

const { context }: ContextStore = useContextStore()

const isMobile = computed(() => context?.flavour === 'mobile')

const props = defineProps<{
  mapData: ContextStore['context']['company_ceo_contacts'][number]
}>()

onMounted(() => {
  if (window.ymaps) {
    const coords = [props.mapData.longitude, props.mapData.latitude].map(coord => {
      const coordStr = String(coord)

      if (coordStr.includes('.')) {
        return Number(coord)
      }

      const data = coordStr.split(',')

      return Number(`${data[0]}.${data[1]}`)
    })

    window.ymaps.ready(() => {
      const map = new window.ymaps.Map('yandex-map', {
        center: [...coords],
        zoom: 17,
      })

      const mark = new window.ymaps.Placemark([...coords], {
        iconCaption: 'ООО МЕДРОКЕТ',
      })

      map.geoObjects.add(mark)
    })
  }
})
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.contacts-map {
  height: 400px;
  overflow: hidden;
  border-radius: $border-radius-sm;
  background-color: $ui-kit-bg-gray-40;

  &--mobile {
    height: 280px;
  }
}
</style>
